import { render, staticRenderFns } from "./DiscountVehicleView.vue?vue&type=template&id=0dc57516&"
import script from "./DiscountVehicleView.vue?vue&type=script&lang=js&"
export * from "./DiscountVehicleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports